import styled from "styled-components";

export const DEFAULT_SIDEBAR_WIDTH = "400px";
// Up to this viewport width the open sidebar covers the page instead of pushing it
export const COVER_MAX_WIDTH = 768;

export const LayoutRow = styled.div`
  width: 100%;
  min-width: 0;
  display: flex;
  flex-direction: row;
  align-items: flex-start;
`;

export const Main = styled.div`
  flex: 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
`;

// NOTE: The sidebar is sized here, not by VoiceChat, which fills the element it is mounted into.
// Pushing the page is done by a spacer in the layout, while the panel itself is fixed to the viewport:
// the bars above the page vary in height, so a panel in the flow could not reliably fit the screen.
export const Spacer = styled.div`
  flex: none;
  width: ${({ $open, $width }) => ($open ? $width : "0")};
  transition: width 0.2s ease-in-out;

  @media (max-width: ${COVER_MAX_WIDTH}px) {
    // Too narrow to share the screen with the page, so the open sidebar covers it instead
    width: 0;
  }
`;

// Stays mounted while closed so the chat keeps a stable element to mount into
export const Panel = styled.aside`
  position: fixed;
  top: 0;
  right: 0;
  z-index: 10;
  width: ${({ $width }) => $width};
  height: calc(100dvh - var(--voice-chat-bottom-offset, 0px));
  overflow: hidden;
  background: var(--background-color);
  ${({ $border }) =>
    $border
      ? `
    border-left-width: 1px;
    border-left-style: solid;
    border-left-color: var(--grey-4, #ddd);
  `
      : "box-shadow: -2px 0 8px rgba(0, 0, 0, 0.08);"}
  // NOTE: Becomes visible at once but is only hidden after sliding out. A panel that is still hidden when the
  // chat opens cannot take the focus that VoiceChat hands it.
  transition:
    transform 0.2s ease-in-out,
    visibility 0s linear ${({ $open }) => ($open ? "0s" : "0.2s")};
  transform: ${({ $open }) => ($open ? "none" : "translateX(100%)")};
  visibility: ${({ $open }) => ($open ? "visible" : "hidden")};

  @media (max-width: ${COVER_MAX_WIDTH}px) {
    width: 100%;
    // NOTE: Covers the navigation's hamburger button (fixed at z-index 2147483646 up to this same width),
    // which would otherwise sit on top of the chat's bottom bar. Beside the page the panel stays low
    // so that modals still go over it.
    z-index: 2147483647;
  }
`;
